import styled from '@emotion/styled';
import { Tag } from 'antd';
import type { FC } from 'react';

type TagProps = React.ComponentProps<typeof Tag>;

interface Props {
  color: TagProps['color'];
  title?: string;
  children: string;
  width: number;
}

export const TrackerTypeTag: FC<Props> = ({ color, title, children, width }) => {
  return (
    <StyledTag color={color} title={title} width={width}>
      {children}
    </StyledTag>
  );
};

const StyledTag = styled(Tag)<{ width: number }>`
  width: ${({ width }) => `${width}px`};
  line-height: 18px;
  text-align: center;
  margin-inline-end: 0px;
  padding-inline: 0px;
`;
